import styled from "styled-components/macro";

import { breakpoint, space } from "shared/styles/constants";

export const StyledImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: ${space.xs};

  height: 100%;

  ${breakpoint("m", "down")} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media print {
    padding: 12px;
  }
`;
